import React from 'react';
import Footer from 'components/views/Footer/Footer';
import Header from 'components/views/Header/Header';
import MypageScheduleFail from 'components/views/MypageScheduleFail/MypageScheduleFail';

export default function MypageScheduleFailWrapper() {
    return (
        <>
            <Header />
            <MypageScheduleFail />
            <Footer />
        </>
    )
}
